<template>
    <div>
        <div style="display:flex">
            <span class="searchtips">发票</span>
            <el-select v-model="orderForm.invoicetype" placeholder="" :disabled="orderForm.cid==0" @change="changeInvoice" style="width:150px">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
            </el-select>
            <el-button v-if="orderForm.invoicetype>0" class="el-icon-edit" @click="openDialog()"></el-button>
        </div>
        <el-dialog :visible.sync="invoiceDialog" title="发票信息更改/补充" width="60%">
            <el-form
                :inline="true"
                :model="tempInvoice"
                :rules="invoicerules"
                ref="tempInvoice"
            >
                <el-form-item
                    label="发票抬头"
                    prop="invoice"
                    :label-width="formLabelWidth"
                >
                    <el-input
                        v-model="tempInvoice.invoice"
                        maxlength="100"
                        style="width: 240px"
                    />
                </el-form-item>
                <el-form-item
                    label="纳税人识别号"
                    prop="taxidentification"
                    :label-width="formLabelWidth"
                >
                    <el-input
                        v-model="tempInvoice.taxidentification"
                        maxlength="50"
                        style="width: 240px"
                    />
                </el-form-item>
                <el-form-item
                    v-if="orderForm.invoicetype == 2"
                    label="地址"
                    :label-width="formLabelWidth"
                    prop="invoiceaddress"
                >
                    <el-input
                        v-model="tempInvoice.invoiceaddress"
                        maxlength="80"
                        style="width: 240px"
                    />
                </el-form-item>
                <el-form-item
                    v-if="orderForm.invoicetype == 2"
                    label="电话"
                    :label-width="formLabelWidth"
                    prop="invoicephone"
                >
                    <el-input
                        v-model="tempInvoice.invoicephone"
                        maxlength="20"
                        style="width: 240px"
                    />
                </el-form-item>
                <el-form-item
                    v-if="orderForm.invoicetype == 2"
                    label="开户银行"
                    :label-width="formLabelWidth"
                    prop="bankname"
                >
                    <el-input
                        v-model="tempInvoice.bankname"
                        maxlength="50"
                        style="width: 240px"
                    />
                </el-form-item>
                <el-form-item
                    v-if="orderForm.invoicetype == 2"
                    label="银行账号"
                    :label-width="formLabelWidth"
                    prop="bankaccountnumber"
                >
                    <el-input
                        v-model="tempInvoice.bankaccountnumber"
                        maxlength="50"
                        style="width: 240px"
                    />
                </el-form-item>
                <el-form-item
                    style="
                        display: block;
                        text-align: center;
                        padding-top: 20px;
                    "
                >
                    <el-button type="primary" @click="saveInvoice"
                        >确认</el-button
                    >
                    <el-button @click="invoiceDialog=false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props:{
        orderForm:{
            type:Object,
            default:{},
        },
    },
    data(){
        return{
            invoiceDialog: false,
            formLabelWidth: "120px",
            options:[
                {
                    value:'0',
                    label:'不开发票',
                },
                {
                    value:'1',
                    label:'增值税普通发票',
                },
                {
                    value:'2',
                    label:'增值税专用发票',
                },
            ],
            tempInvoice: {
                invoice: "",
                taxidentification: "",
                invoiceaddress: "",
                invoicephone: "",
                bankname: "",
                bankaccountnumber: "",
            },
            invoicerules: {
                invoice: [
                    {
                        required: true,
                        message: "请输入发票抬头",
                    },
                ],
                taxidentification: [
                    {
                        required: true,
                        message: "请输入纳税人识别号",
                    },
                ],
                invoiceaddress: [
                    {
                        required: true,
                        message: "请输入联系地址",
                    },
                ],
                invoicephone: [
                    {
                        required: true,
                        message: "请输入手机号",
                    },
                ],
                bankname: [
                    {
                        required: true,
                        message: "请输入开户银行",
                    },
                ],
                bankaccountnumber: [
                    {
                        required: true,
                        message: "请输入开户银行账号",
                    },
                ],
            },
        }
    },
    methods:{
        checkData:function(key){
            if(!this.orderForm.invoice){
                return false;
            }
            if(!this.orderForm.taxidentification){
                return false;
            }
            if(key==2){
                if(!this.orderForm.invoiceaddress){
                    return false;
                }
                if(!this.orderForm.invoicephone){
                    return false;
                }
                if(!this.orderForm.bankname){
                    return false;
                }
                if(!this.orderForm.bankaccountnumber){
                    return false;
                }
            }
            return true;
        },
        changeInvoice:function(e){
            if(e>0){
                if(!this.checkData(e)){
                    this.openDialog();
                }
            }
        },
        openDialog:function(){
            this.tempInvoice.invoice = this.orderForm.invoice;
            this.tempInvoice.taxidentification = this.orderForm.taxidentification;
            this.tempInvoice.invoiceaddress = this.orderForm.invoiceaddress;
            this.tempInvoice.invoicephone = this.orderForm.invoicephone;
            this.tempInvoice.bankname = this.orderForm.bankname;
            this.tempInvoice.bankaccountnumber = this.orderForm.bankaccountnumber;
            this.invoiceDialog = true;
        },
        saveInvoice:function(){
            this.$refs.tempInvoice.validate((valid) => {
                if(valid){
                    if (this.orderForm.invoicetype == 1) {
                        this.$api.customereditCustomerInvoice({
                            id: this.orderForm.cid,
                            invoice: this.tempInvoice.invoice,
                            taxIdentification: this.tempInvoice.taxidentification,
                        }).then((res) => {
                            this.invoiceDialog = false;
                            this.setInvoice();
                            this.$notify({
                                title: "设置发票信息",
                                message: "设置成功",
                                type: "success",
                                duration: 1000,
                            });
                        });
                    } else if (this.orderForm.invoicetype == 2) {
                        this.$api.customereditCustomerInvoice({
                            id: this.orderForm.cid,
                            invoice: this.tempInvoice.invoice,
                            taxIdentification: this.tempInvoice.taxidentification,
                            invoiceaddress: this.tempInvoice.invoiceaddress,
                            invoicephone: this.tempInvoice.invoicephone,
                            bankname: this.tempInvoice.bankname,
                            bankaccountnumber: this.tempInvoice.bankaccountnumber,
                        }).then((res) => {
                            this.invoiceDialog = false;
                            this.setInvoice();
                            this.$notify({
                                title: "设置发票信息",
                                message: "设置成功",
                                type: "success",
                                duration: 1000,
                            });
                        });
                    }
                }else{
                    this.$notify({
                        title: "发票信息未完善",
                        message: "请完善信息",
                        type: "warning",
                        duration: 2000,
                    });
                }
            })
        },
        setInvoice(){
            this.orderForm.invoice = this.tempInvoice.invoice;
            this.orderForm.taxidentification = this.tempInvoice.taxidentification;
            if(this.orderForm.invoicetype == 2){
                this.orderForm.invoiceaddress = this.tempInvoice.invoiceaddress;
                this.orderForm.invoicephone = this.tempInvoice.invoicephone;
                this.orderForm.bankname = this.tempInvoice.bankname;
                this.orderForm.bankaccountnumber = this.tempInvoice.bankaccountnumber;
            }
        }
    }
}
</script>